import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import PayWithButtonGroup from 'components/PayWithButtonGroup';
import { getIsPointsPay } from 'store/ui/uiSelectors';
import { getQueryPayWith } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import { updateQuery as updateQueryAction } from 'store/propertyAvailability/propertyAvailabilityActions';

const PayWith = ({ options, ...rest }) => {
  const payWith = useSelector(getQueryPayWith);
  const isPointsPay = useSelector(getIsPointsPay);
  const dispatch = useDispatch();

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  return <PayWithButtonGroup {...rest} options={options} isDisabled={isPointsPay} payWith={payWith} updateQuery={updateQuery} />;
};

PayWith.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default PayWith;
